import * as Tooltip from '@radix-ui/react-tooltip';
import { StyledTooltipArrow, StyledTooltipContent, StyledTooltipText } from './action-button-tooltip.styles';
import type { ActionButtonTooltipTypes } from './action-button-tooltip.types';
export const ActionButtonTooltip = ({
  children,
  content,
  open
}: ActionButtonTooltipTypes) => <Tooltip.Provider data-sentry-element="unknown" data-sentry-component="ActionButtonTooltip" data-sentry-source-file="action-button-tooltip.tsx">
    <Tooltip.Root open={open} delayDuration={0} data-sentry-element="unknown" data-sentry-source-file="action-button-tooltip.tsx">
      <Tooltip.Portal data-sentry-element="unknown" data-sentry-source-file="action-button-tooltip.tsx">
        <StyledTooltipContent sideOffset={1} data-sentry-element="StyledTooltipContent" data-sentry-source-file="action-button-tooltip.tsx">
          <StyledTooltipText data-sentry-element="StyledTooltipText" data-sentry-source-file="action-button-tooltip.tsx">{content}</StyledTooltipText>
          <StyledTooltipArrow data-sentry-element="StyledTooltipArrow" data-sentry-source-file="action-button-tooltip.tsx" />
        </StyledTooltipContent>
      </Tooltip.Portal>
      <Tooltip.Trigger asChild data-sentry-element="unknown" data-sentry-source-file="action-button-tooltip.tsx">{children}</Tooltip.Trigger>
    </Tooltip.Root>
  </Tooltip.Provider>;